import {useState} from 'react';
import {Input, Button, Row, Col} from 'antd';
import {setUserEmail} from "../../api/Api";

export const SetUserEmail = ({session, onComplete, props}) => {
    const oldEmail = (session && session.email) ?  session.email : undefined
    const [email, setEmail] = useState(oldEmail);

    const onChange = (e) => {
        setEmail(e.target.value);
    }

    const onOk = () => {
        console.log(email);
        setUserEmail(session.id, email).then(r => {
            console.log(`email updated`);
            if (onComplete) {
                onComplete(email);
            }
        }).catch(e => {
            console.log(`error setting email`);
        });
    }

    const disableSave = oldEmail===email

    const rowStyle = {
        marginTop: '5px', marginBottom: '5px'
    }
    return <div>
        <Row style={rowStyle}>
            <b>Set User Email Address </b>
        </Row>
        <Row>
            Update your work email.  System notifications will be sent to this email address
        </Row>
        <Row style={rowStyle}>
            <Col span={8}>
                <Input value={email} placeholder={"e-mail"} onChange={onChange} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Button onClick={onOk} disabled={disableSave}>Save</Button>
        </Row>
    </div>
}